/**
 * PortalLayout, sjednocený rámec portálu (sidebar + obsah), brand mnai.
 * Navigaci dostává jako `items` (role-based) z App.
 */
import React from 'react';
import '../styles/portal.css';

// jednoduché inline ikony
const ICONS = {
  home: <path d="M3 11l9-8 9 8M5 9v11h5v-6h4v6h5V9" strokeWidth="1.6" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" />,
  dashboard: <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />,
  new: <path d="M12 5v14M5 12h14" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" />,
  billing: <path d="M2 7h20v10H2zM2 11h20" strokeWidth="1.6" stroke="currentColor" fill="none" />,
  account: <path d="M12 12a4 4 0 100-8 4 4 0 000 8zm-7 8a7 7 0 0114 0" strokeWidth="1.6" stroke="currentColor" fill="none" strokeLinecap="round" />,
  consult: <path d="M4 5h16v11H9l-4 3v-3H4z" strokeWidth="1.6" stroke="currentColor" fill="none" strokeLinejoin="round" />,
  users: <path d="M16 14a4 4 0 10-8 0M12 10a3 3 0 100-6 3 3 0 000 6zM2 20a5 5 0 0110 0M22 20a5 5 0 00-7-4.5" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinecap="round" />,
  crawler: <path d="M10.5 17a6.5 6.5 0 100-13 6.5 6.5 0 000 13zM20 20l-4.4-4.4" strokeWidth="1.7" stroke="currentColor" fill="none" strokeLinecap="round" />,
};

export function Icon({ name, size = 18 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
      {ICONS[name] || ICONS.dashboard}
    </svg>
  );
}

export function PortalLayout({ items, active, onSelect, email, onLogout, children }) {
  return (
    <div className="portal-shell">
      <aside className="portal-sidebar">
        <div className="portal-logo">M<span className="amp">&amp;</span>Ai</div>
        <nav className="portal-nav">
          {items.map(it => (
            <button
              key={it.key}
              className={`portal-nav-item ${active === it.key ? 'active' : ''}`}
              onClick={() => onSelect(it.key)}
            >
              <Icon name={it.icon} />
              <span className="lbl">{it.label}</span>
            </button>
          ))}
        </nav>
        <div className="portal-user">
          <span className="email">{email}</span>
          <button className="portal-logout" onClick={onLogout}>Odhlásit</button>
        </div>
      </aside>
      <main className="portal-main">{children}</main>
    </div>
  );
}
